import React from 'react';
import { Button, Pane } from 'evergreen-ui';
import { DataValueTSFull, SeriesValue } from './types';
import Measurement from './EditData.Measurement';

type SeriesProps = {
  seriesValues: SeriesValue[]
  zone: string
  onChangeValue: (index: number, value: DataValueTSFull) => void
  addNewTSValue: () => void
}

export default function Series({ seriesValues, zone, onChangeValue, addNewTSValue }: SeriesProps) {
  const [selectedOriginalIndex, setSelectedOriginalIndex] = React.useState(-1);
  const [selectedIndex, setSelectedIndex] = React.useState(-1);

  const existingPoints = React.useMemo(() => seriesValues
    .filter((value) => value.value.point)
    .map((value) => parseInt(value.value.point as string, 10)), [seriesValues]);

  const isDisabledAddButton = React.useMemo(() => seriesValues.some((value) => value.value.isNew), [seriesValues]);

  const onClickAddButton = () => {
    addNewTSValue();
  };

  return (
    <Pane display="grid" gridTemplateColumns="max-content 1fr" overflow="hidden" columnGap=".5rem">
      <Pane maxHeight="350px" overflow="hidden" display="grid" gridTemplateRows="max-content 1fr" rowGap=".5rem">
        <Button onClick={onClickAddButton} disabled={isDisabledAddButton}>Добавить замер</Button>
        <Pane display="grid" gridAutoFlow="row" gridAutoRows="max-content" overflow="auto" rowGap=".2rem">
          {
            React.Children.toArray(seriesValues.map(({ value, index: originalIndex }, index: number) => (
              <Button
                appearance="minimal"
                onClick={() => {
                  setSelectedOriginalIndex(originalIndex);
                  setSelectedIndex(index);
                }}
                isActive={selectedIndex === index}
              >
                {`№${value.point ?? ''}. ${value.value ?? ''}`}

              </Button>
            )))
          }
        </Pane>
      </Pane>
      {selectedOriginalIndex !== -1 && (
        <Measurement
          measurement={seriesValues[selectedIndex].value}
          zone={zone}
          index={selectedOriginalIndex}
          onChangeValue={onChangeValue}
          existingPoints={existingPoints}
          isSeries
        />
      )}
    </Pane>
  );
}
